import { MuiMessages, TranslationMuiMessages } from "../interfaces/muiMessages";

export const messages: TranslationMuiMessages = {
  [MuiMessages.autocompleteLoading]: "Cargando...",
  [MuiMessages.autocompleteNoOptions]: "Sin opciones"
};
